export default function outils_evenement() {
    let outils_evenement =
        <>
            <h4>Nos outils</h4>
            <p>Production et Captation vidéo | Photographie<br />
                Supports promotionnels | Campagnes pré et post-événement<br />
                Direction artistiques | Scénographie et coordination logistique<br />
                Campagnes pré-événement et post-événement
            </p>
        </>

    return outils_evenement;
}